import { contract } from 'lib/contract';

import * as page from './page';
import * as model from './model';
export { PageAssemblyList } from './page';

contract({
  page,
  model
})